import React, { useContext, useEffect, useState } from "react";
import "./Style.css";
import { SidebarData } from "./SidebarData";
import { Link, useLocation, useNavigate } from "react-router-dom";
import LimitsContext from "../../../contextApi/backlink/LimitsContext";
import { getAPIUrlBM } from "../../../utils/config";
import Get from "../../../Apis/backlink/Get";
import { auth2 } from "../../../firebase";
import ContactIcon from "../Assets/ContactIcon";
import FAQ from "../Assets/FAQIcon";
import { PlanInfo } from "../../utils/backLinkPlanInfo";
import { useSelector } from "react-redux";
import GET from "../../../Apis/backlink/Get";

function Sidebar() {
  const {
    totalBackLinks,
    bklCrawledPerMonth,
    // totalbklCrawled,
    setBackLinkLimits,
    // totalDomainsDeleted,
    getDomainCount,
    domainCount,
  } = useContext(LimitsContext);
  const [planType, setPlanType] = useState("");
  const [planName, setPlanName] = useState("Free Plan");
  const [totalDomains, setTotalDomains] = React.useState(0);
  const [usedDomains, setUsedDomains] = React.useState(0);
  const [plan, setPlan] = React.useState("plan1");
  const [userConsoleData, setUserConsoleData] = React.useState([]);

  useEffect(() => {
    auth2.currentUser.getIdTokenResult().then((idTokenResult) => {
      console.log(idTokenResult.claims, "CUSTOM_CLAIMS");
      const { addOns, plan: myplan } = idTokenResult.claims;

      if (myplan) setPlan(myplan);
      if (Array.isArray(addOns)) {
        const indexmenow = addOns.find((item) => item.name === "indexmenow");

        if (indexmenow) {
          setTotalDomains(indexmenow.limit);
          // setUsedDomains(indexmenow.usedDomains);
        }
      }
    });
  }, []);

  const getUserConsoleData = async () => {
    try {
      const response = await GET(getAPIUrlBM() + "/get-user-console-data/");
      const { data, backLinkLimits } = response;
      console.log(backLinkLimits);
      if (backLinkLimits) {
        setUsedDomains(backLinkLimits["POST/active-domain"] || 0);
      }
      setUserConsoleData(data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getUserConsoleData();
  }, []);

  let location = useLocation();
  const navigate = useNavigate();
  const [curPath, setCurPath] = useState("/backlink/list");

  const { workspace, currentWorkSpaceUsers } = useSelector(
    (data) => data.userData,
  );
  const [currentSpace, setCurrentSpace] = useState(null);

  useEffect(() => {
    getDomainCount();
  }, []);
  useEffect(() => {
    let pathArray = location.pathname.split("/");
    if (pathArray[3] != undefined)
      setCurPath("/" + pathArray[1] + "/" + pathArray[2] + "/" + pathArray[3]);
    else setCurPath("/" + pathArray[1] + "/" + pathArray[2]);
    console.log(curPath);
  }, [location]);

  const getLimitsAndSet = async () => {
    try {
      const url = getAPIUrlBM();
      const res = await Get(url + "/getLimits");
      setBackLinkLimits(res.backLinkLimits);
      if (res.backLinkLimits?.upgradePlan) navigate("/backlink/upgrade");
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getLimitsAndSet();
    const get = async () => {
      try {
        let paid;
        if (localStorage.getItem("workspaceId")) {
          const url = getAPIUrlBM();
          const res = await Get(url + "/getuserbyuid");
          console.log({ sidebarUserRes: res });
          if (res.data.custom) {
            paid = res.data.custom;
          }
        } else {
          paid = auth2.currentUser.reloadUserInfo?.customAttributes;
        }
        console.log({ sidebPaid: paid });
        if (paid !== undefined && typeof paid === "string") {
          paid = JSON.parse(paid);
          paid = { plan: paid.plan };
          if (paid.trialPlan) {
            paid = { plan: paid.trialPlan };
          }
        } else if (!paid) {
          paid = { plan: "plan1" };
        }

        console.log({ paid });
        setPlanType(paid.plan);

        //* setting plan name
        if (paid?.plan === "plan1") setPlanName("Free Plan");
        else if (paid?.plan === "plan2") setPlanName("Tier - 1");
        else if (paid?.plan === "plan3") setPlanName("Tier - 2");
        else if (paid?.plan === "plan4") setPlanName("Tier - 3");
        else if (paid?.plan === "plan5") setPlanName("Tier - 4");
        else if (paid?.plan === "plan6") setPlanName("Tier - 5");
        else if (paid?.plan === "plan7") setPlanName("Tier - 6");
        else if (paid?.plan === "plan8") setPlanName("Tier - 7");
        else if (paid?.plan === "plan9") setPlanName("Tier - 8");
        else if (paid?.plan === "plan10") setPlanName("Tier - 9");
        else if (paid?.plan === "plan11") setPlanName("Tier - 10");
        else if (paid?.plan === "plan12") setPlanName("Tier - 11");
        else if (paid?.plan === "plan13") setPlanName("Tier - 12");
        else if (paid?.plan === "plan14") setPlanName("Tier - 13");
        else if (paid?.plan === "plan15") setPlanName("Tier - 14");
        else if (paid?.plan === "plan16") setPlanName("Tier - 15");
        else if (paid?.plan === "plan17") setPlanName("Tier - 16");
        else if (paid?.plan === "plan18") setPlanName("Tier - 17");
        else if (paid?.plan === "plan19") setPlanName("Tier - 18");
        else if (paid?.plan === "plan20") setPlanName("Tier - 19");
        else if (paid?.plan === "plan21") setPlanName("Tier - 20");
        else if (paid?.plan === "plan22") setPlanName("Tier - 21");
        else if (paid?.plan === "plan23") setPlanName("Tier - 22");
        else if (paid?.plan === "plan24") setPlanName("Tier - 23");
        else if (paid?.plan === "plan25") setPlanName("Tier - 24");
        else if (paid?.plan === "plan26") setPlanName("Tier - 25");
        else {
          setPlanName(paid?.plan || "Free Plan");
        }
      } catch (error) {
        console.log(error);
      }
    };
    // console.log("sidebar from backlink");
    get();
  }, [location]);

  useEffect(() => {
    setCurrentSpace(
      ...workspace?.filter(
        (item) =>
          item.ownerId === localStorage.getItem("workspaceId")?.toString(),
      ),
    );
  }, [workspace]);

  return (
    <div className="backLinkSidebarContianer">
      <div className="sidebarButtons">
        {(!currentSpace || currentSpace?.roles?.includes("Add Backlink")) && (
          <button
            onClick={() => navigate("/backlink/link/add")}
            className={
              curPath === "/backlink/link/add"
                ? "activeSidebarButton"
                : "unActiveSidebarButton"
            }
          >
            Add Backlink
          </button>
        )}
        {(!currentSpace ||
          currentSpace?.roles?.includes("Create New List")) && (
          <button
            onClick={() => navigate("/backlink/list/add")}
            className={
              curPath === "/backlink/list/add"
                ? "activeSidebarButton"
                : "unActiveSidebarButton"
            }
          >
            Create New List
          </button>
        )}
      </div>

      <ul className="sidebarList">
        {SidebarData.filter(
          (route) =>
            !currentSpace || currentSpace?.roles?.includes(route.title),
        ).map((item, index) => {
          return (
            <div key={index} className="backlink_route">
              <Link
                to={item.path}
                className="links"
                style={{
                  position: "relative",
                }}
              >
                <li
                  key={index}
                  className="siderbarItem"
                  id={curPath === item.path ? "active" : ""}
                >
                  <div className="left_side_route_name">
                    <div>
                      <span>{item.icon}</span>
                      <span
                        className={
                          item.title === "Dashboard"
                            ? "dashboardTitle"
                            : "titleSidebar"
                        }
                      >
                        {item.title}{" "}
                      </span>
                    </div>
                    {item.new && <span className="newIcon">New</span>}
                  </div>

                  {/* Show all subroutes of this route */}
                  {item.subRoutes && (
                    <svg
                      width="10"
                      height="6"
                      viewBox="0 0 10 6"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M1 1L4.92929 4.92929C4.96834 4.96834 5.03166 4.96834 5.07071 4.92929L9 1"
                        stroke="#4F4F4F"
                        stroke-width="1.5"
                        stroke-linecap="round"
                      />
                    </svg>
                  )}
                </li>
              </Link>
              {item?.subRoutes && (
                <div
                  className={`subRoutes ${
                    curPath === item.path ||
                    item.subRoutes?.some(
                      (subRoute) => curPath === subRoute.path,
                    )
                      ? "SubrouteActive"
                      : "CloseSubroute"
                  } `}
                >
                  {item?.subRoutes?.map((subRoute, index) => {
                    return (
                      <Link
                        to={subRoute.path}
                        className="links"
                        key={index + "subroute"}
                      >
                        <li
                          key={subRoute.path}
                          className="siderbarItem"
                          id={curPath === subRoute.path ? "active" : ""}
                        >
                          <div className="left_side_route_name">
                            <div>
                              <span>{subRoute.icon}</span>
                              <span className={"titleSidebar"}>
                                {subRoute.title}{" "}
                              </span>
                            </div>
                          </div>
                        </li>
                      </Link>
                    );
                  })}
                </div>
              )}
            </div>
          );
        })}
      </ul>

      <ul className="sidebarList">
        <li className="siderbarItem">
          <a
            className="links"
            href={"http://links.backlinkchecker.info/faq"}
            target="_blank"
          >
            <div>
              <span>
                <FAQ />
              </span>
              <span className={"titleSidebar"}>FAQ </span>
            </div>
          </a>
        </li>
        <li className="siderbarItem">
          <a
            className="links"
            href={
              "mailto:yogi@backlinkchecker.info"
            }
            target="_blank"
            rel="noreferrer"
          >
            <div>
              <span>
                <ContactIcon />
              </span>
              <span className={"titleSidebar"}>Contact Support </span>
            </div>
          </a>
        </li>
      </ul>

      <div className="limitContainer">
        <p>Current Plan</p>
        <p className="planName">{planName}</p>
        <p>
          Shows used limits
          <br />
          <span style={{ fontSize: "10px" }}>
            (Monthly limits reset on first day of month)
          </span>
        </p>

        <div className="limitItem">
          <p>Monthly Backlinks crawled:</p>
          <p style={{ color: "#0048A1" }}>
            <span style={{ fontWeight: "bolder", fontSize: "14px" }}>
              {bklCrawledPerMonth}
            </span>{" "}
            out of {PlanInfo[planType]?.bklCrawledPerMonth} used
          </p>
        </div>
        <div className="limitItem">
          <p>Total backlinks to monitor:</p>
          <p style={{ color: "#0048A1" }}>
            <span style={{ fontWeight: "bolder", fontSize: "14px" }}>
              {totalBackLinks}
            </span>{" "}
            out of {PlanInfo[planType]?.totalBackLinks} this month
          </p>
        </div>
        <div className="limitItem">
          <p>Total Domains Used:</p>
          <p style={{ color: "#0048A1" }}>
            <span style={{ fontWeight: "bolder", fontSize: "14px" }}>
              {domainCount}
            </span>{" "}
            out of {PlanInfo[planType]?.domains}
          </p>
        </div>
        <div className="limitItem">
          <p>Total Users:</p>
          <p style={{ color: "#0048A1" }}>
            <span style={{ fontWeight: "bolder", fontSize: "14px" }}>
              {currentWorkSpaceUsers}
            </span>{" "}
            out of {PlanInfo[planType]?.num_users}
          </p>
        </div>
        <br />
        <p>
          IndexMySite Addon
          <br />
          <span style={{ fontSize: "10px" }}>(As per your current plan)</span>
        </p>

        <div className="limitItem">
          <span>Total Domains:</span>
          <p
            style={{
              color: "#0048A1",
            }}
          >
            <span
              style={{
                fontWeight: "bolder",
                fontSize: "14px",
              }}
            >
              {+totalDomains + PlanInfo[plan].indexmenow}
            </span>{" "}
            Domains
          </p>
        </div>
        <div className="limitItem">
          <span>Used Domains:</span>
          <p
            style={{
              color: "#0048A1",
            }}
          >
            <span
              style={{
                fontWeight: "bolder",
                fontSize: "14px",
              }}
            >
              {usedDomains}
            </span>{" "}
            Domains
          </p>
        </div>

        {/* <div className="limitItem">
          <p>Total backlinks crawled:</p>
          <p style={{ color: "#0048A1" }}>
            <span style={{ fontWeight: "bolder", fontSize: "14px" }}>
              {totalbklCrawled}
            </span>{" "}
            out of {PlanInfo[planType]?.totalbklCrawled} used
          </p>
        </div>
        <div className="limitItem">
          <p>Domains:</p>
          <p style={{ color: "#0048A1" }}>
            <span style={{ fontWeight: "bolder", fontSize: "14px" }}>
              0
            </span>{" "}
            out of {PlanInfo[planType]?.domains} used
          </p>
        </div>
        <div className="limitItem">
          <p>Users:</p>
          <p style={{ color: "#0048A1" }}>
            <span style={{ fontWeight: "bolder", fontSize: "14px" }}>
              0
            </span>{" "}
            out of {PlanInfo[planType]?.num_users} used
          </p>
        </div> */}
      </div>
    </div>
  );
}

export default Sidebar;
